import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Chip,
  CircularProgress,
  Container,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import {
  Button
} from "@material-ui/core";
import {
  Add as AddIcon,
  Assignment as AssignmentIcon,
  Close as CloseIcon,
  Search as SearchIcon
} from '@mui/icons-material';
import MainContainer from '../../components/MainContainer';
import { headerBanqueCV } from '../../data/modules/banque-cv-header';
import ClasseService from '../../services/ClasseService';
import EvaluationCoursService from '../../services/EvaluationCoursService';
import EvaluationAdd from './EvaluationAdd';

const EvalutionList = () => {
  const [evaluations, setEvaluations] = useState([]);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    const [evaluationsResult, classesResult] = await Promise.all([
      EvaluationCoursService.getAllEvaluations(),
      ClasseService.getAllClasses()
    ]);

    setEvaluations(evaluationsResult?.status === true ? evaluationsResult.data || [] : []);
    setClasses(classesResult?.status === true ? classesResult.data || [] : []);
    setLoading(false);
  };

  const filteredEvaluations = useMemo(() => {
    const term = searchTerm.toLowerCase();
    return evaluations.filter((evaluation) => {
      const title = (evaluation.title || '').toLowerCase();
      const classNames = (evaluation.classes || '').toLowerCase();
      return title.includes(term) || classNames.includes(term);
    });
  }, [evaluations, searchTerm]);

  const openCreateModal = () => {
    setModalOpen(true);
  };

  const handleSaved = () => {
    setModalOpen(false);
    loadData();
  };

  return (
    <MainContainer {...headerBanqueCV}>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AssignmentIcon sx={{ fontSize: 32, color: 'primary.main' }} />
            <Typography variant="h4" component="h1">
              Évaluations
            </Typography>
          </Box>
          <Button variant="contained" startIcon={<AddIcon />} onClick={openCreateModal}>
            Nouvelle évaluation
          </Button>
        </Box>

        <Box sx={{ mb: 3 }}>
          <TextField
            sx={{ width: { xs: '100%', md: 460 } }}
            variant="outlined"
            placeholder="Rechercher une évaluation..."
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm('')} edge="end">
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Box>

        <Box sx={{ mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip label={`Total: ${filteredEvaluations.length}`} color="primary" variant="outlined" />
          {searchTerm && (
            <Chip
              label={`Recherche: "${searchTerm}"`}
              color="secondary"
              variant="outlined"
              onDelete={() => setSearchTerm('')}
            />
          )}
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: 'primary.main' }}>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>N°</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Titre</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Classes</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Session N°</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Questions</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Certificat</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Statut</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : filteredEvaluations.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
                    <Typography color="text.secondary">Aucune évaluation trouvée</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredEvaluations.map((evaluation, index) => (
                  <TableRow key={evaluation.id} hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Typography variant="subtitle2" fontWeight="700">
                        {evaluation.title}
                      </Typography>
                    </TableCell>
                    <TableCell>{evaluation.classes || '-'}</TableCell>
                    <TableCell>{evaluation.id || '-'}</TableCell>
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <EvaluationAdd
          open={modalOpen}
          classes={classes}
          onClose={() => setModalOpen(false)}
          onSaved={handleSaved}
        />
      </Container>
    </MainContainer>
  );
};

export default EvalutionList;
